import { render, staticRenderFns } from "./FormatTwoPaneSelector.vue?vue&type=template&id=4be2336c&scoped=true&"
import script from "./FormatTwoPaneSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatTwoPaneSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatTwoPaneSelector.vue?vue&type=style&index=0&id=4be2336c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be2336c",
  null
  
)

export default component.exports